import { RoutablePage, configQuery, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate } from 'tslib';
import { Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { USER_LOGOUT_KEYCLOAK } from '@gig/magic-messages';

var TimeOutComponent = /** @class */ (function (_super) {
    __extends(TimeOutComponent, _super);
    function TimeOutComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selectedDuration = null;
        _this.durations = [];
        return _this;
    }
    TimeOutComponent.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTimeOutDurations()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TimeOutComponent.prototype.timeOut = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, magic.methods.responsibleGaming.createUserSuspensionLimit(this.selectedDuration)];
                    case 1:
                        _a.sent();
                        window.commandBus.publish(USER_LOGOUT_KEYCLOAK, this.getFullHref({ route: RoutablePage.HOME }));
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error('Time-Out:', e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TimeOutComponent.prototype.getTimeOutDurations = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = this;
                        return [4 /*yield*/, configQuery('timeOutDurations')];
                    case 1:
                        _b.durations =
                            (_a = (_c.sent())) !== null && _a !== void 0 ? _a : [];
                        return [2 /*return*/];
                }
            });
        });
    };
    TimeOutComponent.prototype.getDurationTranslation = function (duration) {
        return this.$t("time-out." + duration + ".label");
    };
    TimeOutComponent = __decorate([
        Component({
            name: 'corex-time-out',
        })
    ], TimeOutComponent);
    return TimeOutComponent;
}(Mixins(MagicConfigMixin)));

export default TimeOutComponent;
